import type { CreditsChargeResult } from '@patsnap/credits-charge';

/** 积分检查未执行的原因。 */
export type CreditsChargeSkippedReason = 'not-logged-in' | 'not-oversea';

/** 应用侧积分检查结果，包含 SDK 结果和宿主环境门禁结果。 */
export type CreditsChargeInitializationResult = CreditsChargeResult | {
    status: 'skipped';
    reason: CreditsChargeSkippedReason;
};

/** 封装新用户积分资格检查、领取和成功 Toast。 */
export interface CreditsChargeService {
    /**
     * 为当前用户执行一次积分检查与领取。
     * @returns SDK 业务结果，或当前宿主不满足执行条件时的跳过结果。
     */
    checkAndClaim(): Promise<CreditsChargeInitializationResult>;
}

/** 积分领取服务的容器标识。 */
export const CreditsChargeService = Symbol('CreditsChargeService');
